<eda-dialog2 [display]="display" [header]="title" width="80vw" height="80vh" [overflow]="'auto'"
  (apply)="saveChartConfig()" (close)="closeChartConfig()">

  <div content class="flex flex-col md:flex-row flex-1 overflow-hidden h-[70vh]">
    <!-- Chart Preview -->
    <div class="p-6 flex-[2] flex items-center justify-center border-b md:border-b-0 md:border-r bg-slate-50">
      <div class="relative w-full h-full">
        @if (display) {
          <panel-chart #PanelChartComponent
            [props]="panelChartConfig"
            class="h-full w-full block"
          ></panel-chart>
        }
      </div>
    </div>

    <div class="p-6 flex-[1] overflow-y-auto">
      <div class="space-y-6">
        <!-- Colors -->
        <div class="space-y-4">
          <span class="text-lg font-semibold" i18n="@@colorsChartH6">Colores</span>
          <h6 i18n="@@ChangeDefaultsColors" class="mb-1">Color de los gráficos:</h6>

          <div class="flex items-stretch gap-2 mb-4">
            <p-dropdown
              [(ngModel)]="selectedPalette"
              [options]="allPalettes"
              optionLabel="name"
              i18n-placeholder="@@selectPalette"
              placeholder="-- Seleccione una paleta --"
              (ngModelChange)="onPaletteSelected()"
              [style]="{'width':'180px'}"
              appendTo="body">
            </p-dropdown>
            @if (selectedPalette) {
              <div class="flex rounded overflow-hidden" style="width: 80px;">
                @for (color of selectedPalette.paleta.slice(0, 8); track $index) {
                  <div class="flex-1" [style.background-color]="color"></div>
                }
              </div>
            }
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex items-center justify-between border rounded-lg p-3 bg-white hover:bg-slate-50">
              <span class="font-medium" i18n="@@layerColor">Color de capa</span>
              <div class="flex items-center gap-2">
                <input [(ngModel)]="assignedColors[0].color" (input)="handleInputColor()" class="text-md text-slate-500 font-mono w-[3.5vw]">
                <p-colorPicker [(ngModel)]="assignedColors[0].color" (onChange)="handleInputColor()" format="hex" appendTo="body" />
              </div>
            </div>
          </div>
        </div>

        <!-- EscalaLogaritmica -->
        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <label for="logarithmic-switch" class="block text-base font-medium" i18n="@@logarithmicScale">Escala logarítmica</label>
              <div class="relative group">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="text-slate-400">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 16v-4"></path>
                  <path d="M12 8h.01"></path>
                </svg>
                <div class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                  <span i18n="@@logarithmicScaleTooltip">Aplica escala logarítmica a los valores del mapa</span>
                </div>
              </div>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" [(ngModel)]="logarithmicScale" class="sr-only peer" (ngModelChange)="renderMap()">
              <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all corp-toggle"></div>
            </label>
          </div>
        </div>

        <!-- Mouse -->
        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <label for="mouse-functions-switch" class="block text-base font-medium" i18n="@@activeMouseFunctions">Activar funciones del ratón</label>
              <div class="relative group">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="text-slate-400">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 16v-4"></path>
                  <path d="M12 8h.01"></path>
                </svg>
                <div class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                  <span i18n="@@activeMouseFunctionsTooltip">Permite arrastrar y hacer zoom con el ratón</span>
                </div>
              </div>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" [(ngModel)]="draggable" (onChange)="nullMouseOptions()" class="sr-only peer">
              <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all corp-toggle"></div>
            </label>
          </div>
        </div>

        <!-- BaseLayer Active -->
        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <label class="block text-base font-medium" i18n="@@enableBaseLayer">Activar capa base</label>
              <div class="relative group">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="text-slate-400">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 16v-4"></path>
                  <path d="M12 8h.01"></path>
                </svg>
                <div class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                  <span i18n="@@enableBaseLayerTooltip">Muestra u oculta la capa base del mapa</span>
                </div>
              </div>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" [(ngModel)]="baseLayer" (ngModelChange)="modifyBaseLayer()" class="sr-only peer">
              <div
                class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all corp-toggle">
              </div>
            </label>
          </div>
        </div>

        <!-- LegendPosition -->
        <div class="space-y-4">
          <label class="block text-base font-medium" i18n="@@legendPosition">Posición de la leyenda</label>
          <div class="grid grid-cols-2 gap-2">
            <div class="flex items-center space-x-2 border rounded-md p-2">
              <input 
                type="radio" 
                id="topleft" 
                name="legendPosition" 
                (input)="changeLegend('topleft')" 
                [checked]="this.legendPosition === 'topleft' "
                class="h-4 w-4 accent-corp"
              />
              <label for="topleft" class="text-base" i18n="@@topleftPosition">Superior izquierda</label>
            </div>
            <div class="flex items-center space-x-2 border rounded-md p-2">
              <input 
                type="radio" 
                id="topright" 
                name="legendPosition" 
                (input)="changeLegend('topright')" 
                [checked]="this.legendPosition === 'topright' "
                class="h-4 w-4 accent-corp"
              />
              <label for="topright" class="text-base" i18n="@@toprightPosition">Superior derecha</label>
            </div>
            <div class="flex items-center space-x-2 border rounded-md p-2">
              <input 
                type="radio" 
                id="bottomleft" 
                name="legendPosition" 
                (input)="changeLegend('bottomleft')" 
                [checked]="this.legendPosition === 'bottomleft' "
                class="h-4 w-4 accent-corp"
              />
              <label for="bottomleft" class="text-base" i18n="@@bottomleftPosition">Inferior izquierda</label>
            </div>
            <div class="flex items-center space-x-2 border rounded-md p-2">
              <input 
                type="radio" 
                id="bottomright" 
                name="legendPosition" 
                (input)="changeLegend('bottomright')" 
                [checked]="this.legendPosition === 'bottomright' "
                class="h-4 w-4 accent-corp"
              />
              <label for="bottomright" class="text-base" i18n="@@bottomrightPosition">Inferior derecha</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</eda-dialog2>

  